module.exports = __webpack_public_path__ + "static/media/nile shot 1-mobile.75708136.webp";